import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { HashRouter as Router } from "react-router-dom";
import { ItemsProvider } from './context/ItemsContext';
import { AuthProvider } from "./components/authentication/AuthContext";
import { BillProvider } from "./context/BillContext";
import { GstDiscountProvider } from "./context/GstDiscountContext";
import { CategoryProvider } from "./context/CategoryContext";

import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Router>
        <AuthProvider>
          <CategoryProvider>
          <ItemsProvider>
            <BillProvider>
            <GstDiscountProvider>
            <App />
            </GstDiscountProvider>
            </BillProvider>
          </ItemsProvider>
          </CategoryProvider>
        </AuthProvider>
      </Router>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register Service Worker for PWA offline capabilities
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("./service-worker.js")
      .then((reg) => console.log("Service Worker registered successfully:", reg.scope))
      .catch((err) => console.error("Service Worker registration failed:", err));
  });
}
